webpackJsonp([245643399531540],{

/***/ 2133:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"PlainDecimal","kind":"SCALAR","type":"OBJECT","fields":null,"description":"An arbitrary-precision decimal serialized in plain (non-scientific) notation.\n\nThe default `:decimal` scalar delegates to `Decimal.to_string/1`, which uses\n`:scientific` notation in `Decimal` v2 (e.g. `1E-9`). Microdose values must\nreach the UI as a human-readable string like `0.000000001`, so this scalar\nforces `:normal` notation on serialize. Parsing is identical to `:decimal`.","enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---scalar-plain-decimal-c3d59a6756c1cd05e5c1.js